'use client';

import { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Progress,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from '@chakra-ui/react';
// import { Link } from '@chakra-ui/react';
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { AndroidLogo, AppleLogo, WindowsLogo } from 'components/icons/Icons';
import axios from 'axios';
import * as React from 'react';
import { Badge, Button, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loader from '../dataTables/Loader';
import { ReduxContext } from 'contexts/redux/ReduxState';
import { Pagination } from 'components/utils/Pagination';
// import { set } from 'react-datepicker/dist/date_utils';

const columnHelper = createColumnHelper();

export default function Marketplace(props) {
  const [transactionLoaderState, setTransactionLoaderState] = useState(false);
  const [data, setData] = useState([]);
  const [dataToDisplay, setDataToDisplay] = useState([]);
  const [offset, setOffset] = useState(10);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [ledger, setLedger] = useState([]);
  const [error, setError] = useState(null);
  const [allMerchantList, setallMerchantList] = useState([]);
  const [sorting, setSorting] = useState([]);
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const iconColor = useColorModeValue('secondaryGray.500', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  // let defaultData = tableData;

  useEffect(() => {
    setPages(Math.floor((ledger.length + (offset - 1)) / offset));
    const startIdx = 0;
    const endIdx = offset - 1;
    setTotal(ledger.length);
    const filteredData = ledger.filter((bank, idx) => {
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
  }, [ledger]);

  useEffect(() => {
    let filteredData = data.filter((bank) => {
      let b = false;
      if (data.length > 0) {
        for (let key in data[0]) {
          if (
            bank[key] &&
            bank[key]
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase())
          ) {
            b = true;
          }
        }
      }
      return b;
    });
    setPages(Math.floor((filteredData.length + 999) / 1000));
    setTotal(filteredData.length);
    const startIdx = 0;
    const endIdx = 999;
    filteredData = filteredData.filter((bank, idx) => {
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
    setCurrentPage(1);
  }, [searchText]);

  useEffect(() => {
    let filteredData = data.filter((bank) => {
      let b = false;
      if (data.length > 0) {
        for (let key in data[0]) {
          if (
            bank[key] &&
            bank[key]
              .toString()
              .toLowerCase()
              .includes(searchText.toString().toLowerCase())
          ) {
            b = true;
          }
        }
      }
      return b;
    });
    console.log(filteredData);
    const startIdx = (currentPage - 1) * offset;
    const endIdx = currentPage * offset - 1;
    console.log({ startIdx, endIdx });
    filteredData = filteredData.filter((bank, idx) => {
      console.log(idx, idx <= endIdx && idx >= startIdx);
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
    console.log({ startIdx, endIdx });
  }, [currentPage, offset]);

  // did mount
  useEffect(() => {
    setPages(Math.floor((data.length + (offset - 1)) / offset));
    const startIdx = 0;
    const endIdx = offset - 1;
    setTotal(data.length);
    console.log(startIdx);
    console.log(data);
    const filteredData = data.filter((bank, idx) => {
      return idx <= endIdx && idx >= startIdx;
    });
    console.log(filteredData);
    setDataToDisplay(filteredData);
  }, [data, offset]);

  useEffect(() => {
    setPages(Math.floor((ledger.length + (offset - 1)) / offset));
    const startIdx = 0;
    const endIdx = offset - 1;
    setTotal(ledger.length);
    const filteredData = ledger.filter((bank, idx) => {
      return idx <= endIdx && idx >= startIdx;
    });
    setDataToDisplay(filteredData);
  }, [ledger]);

  const AllMerchentListAPi = async () => {
    const rawData = {
      merchantId: '2',
    };

    try {
      setTransactionLoaderState(true);
      const response = await axios.post(
        `https://bumppy.in/payin/api/sdkClientGetAllMerchants.php`,
        rawData,
      );

      if (response.status === 200) {
        if (response.data.status == '00') {
          setData(response.data.data);
        }
      } else {
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.error('Error fetching report data:', error);
    } finally {
      setTransactionLoaderState(false);
    }
    // setData(data.data)
  };
  useEffect(() => {
    AllMerchentListAPi();
  }, []);

  // const [data, setData] = React.useState(() => [...defaultData]);

  const headers = [
    { id: 'id', label: 'Sr' },
    { id: 'merchantId', label: 'Merchant Id' },
    { id: 'businessName', label: 'Business Name' },
    { id: 'balance', label: 'Unsettled Amount' },
    { id: 'date', label: 'OnBoarding Date' },
  ];

  return transactionLoaderState ? (
    <Loader />
  ) : (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: 'scroll', lg: 'hidden' }}
      style={{ marginTop: '5rem' }}
    >
      <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          className="mt-4"
        >
          Settlement Process
        </Text>
      </Flex>
      <Box>
        <Table variant="simple" color="gray.500" mb="24px" mt="12px">
          <Thead>
            <Tr>
              {headers.map((header) => (
                <Th
                  key={header.id}
                  pe="10px"
                  borderColor={borderColor}
                  cursor="pointer"
                >
                  <Flex
                    justifyContent="space-between"
                    align="center"
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color="gray.400"
                  >
                    {header.label}
                  </Flex>
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {dataToDisplay.map((item, index) => (
              <Tr
                key={item._id}
                style={{
                  border: 'none',
                  height: '3rem',
                  backgroundColor: 'white',
                  color: 'black',
                }}
              >
                <Td
                  style={{ border: 'none' }}
                  className="text-center align-middle"
                  fontSize={{ sm: '10px', lg: '13px' }}
                >
                  {index + 1}
                </Td>
                <Td
                  style={{ border: 'none' }}
                  className="text-center align-middle"
                  fontSize={{ sm: '10px', lg: '13px' }}
                >
                  {item.merchantId}
                </Td>
                <Td
                  style={{ border: 'none', color: 'blue' }}
                  className="text-center align-middle"
                  fontSize={{ sm: '10px', lg: '13px' }}
                >
                  <Link to={`/admin/settlement?merchantId=${item.merchantId}`}>
                    {item.BusinessName}
                  </Link>
                </Td>
                <Td
                  style={{ border: 'none' }}
                  className="text-center align-middle"
                  fontSize={{ sm: '10px', lg: '13px' }}
                >
                  {item.PaymentAPIBalance || 'NA'}
                </Td>
                <Td
                  style={{ border: 'none' }}
                  className="text-center align-middle"
                  fontSize={{ sm: '10px', lg: '13px' }}
                >
                  {item.onboardingDate || 'NA'}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Pagination
          page={currentPage}
          limit={pages}
          callback={(page) => {
            setCurrentPage(page);
          }}
          count={dataToDisplay.length}
          total={total}
          callback2={(offsetValue) => {
            setOffset(offsetValue);
          }}
        />
      </Box>
    </Card>
  );
}
